export const INITIAL_VALUES_PATIENT = {
    first_name: '',
    last_name: '',
    middle_name: '',
    preferred_name: '',
    dob: '',
    phone_number: '',
    email: '',
    sex: '',
    address_one: '',
    address_two: '',
    city: '',
    zip_code: '',
    state: '',
    gender: '',
    orientation:'',
    race:'',
    ethnicity: '',
    preferredlanguage:'',
    timeZone: '',
}
